import { render, staticRenderFns } from "./ProductOrganicPage.vue?vue&type=template&id=e3c4b268&scoped=true&"
import script from "./ProductOrganicPage.vue?vue&type=script&lang=js&"
export * from "./ProductOrganicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c4b268",
  null
  
)

export default component.exports